import React from 'react';
import { PublicChosenCharityContext } from './publicChosenCharityProvider';

export const useChosenPublicCharity = () => React.useContext(PublicChosenCharityContext);
